import React, { useState, useEffect } from 'react';
import { FaAngleDown, FaLayerGroup, FaBox, FaChartBar, FaExchangeAlt, FaHistory, FaMinus, FaUser, FaNewspaper } from 'react-icons/fa';
import { IoHome } from "react-icons/io5";
import { MdOutlineSupportAgent } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

function Sidebar({ isOpen, toggleSidebar }) {
  const [expandedSection, setExpandedSection] = useState(null); // Track the currently expanded section  
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Check if the user is authenticated and set the user info from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
        try {
            setUser(JSON.parse(storedUser)); // Parse and set user data
            console.log('User data:', JSON.parse(storedUser)); // Log user data for debugging
        } catch (error) {
            console.error('Error parsing user data:', error);
        }
    }
}, []);

  // Function to handle section expansion and collapse  
  const toggleSection = (section) => {
    setExpandedSection(prev => (prev === section ? null : section)); // Toggle the section  
  };

  const handleNavigation = (path, section) => {
    toggleSection(section); // Ensure only one section is expanded  
    navigate(path); // Navigate to the selected path  
    toggleSidebar(); // Optionally close the sidebar after navigation  
  };

  if (!isOpen) return null; // Render nothing if closed  

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <span className="sidebar-logo">OANDA</span>
        <span className="sidebar-profile-icon" style={{ backgroundColor: '#ccc' }}>P</span>
        <div className="sidebar-profile-details">
          {/* Display username and email from localStorage */}
          {user ? (
            <>
              <div className="sidebar-profile-name">{user.username}</div>
              <div className="sidebar-profile-email">{user.email}</div>
            </>
          ) : (
            <>
              <div className="sidebar-profile-name">Guest</div>
              <div className="sidebar-profile-email">Not logged in</div>
            </>
          )}
        </div>
      </div>
      <div className="sidebar-body">
        <ul>
          <li>
            <button
              className="sidebar-button"
              onClick={() => toggleSection('overview')}
            >
              <span className="sidebar-icon"><FaLayerGroup /></span> Overview
              <span className="angle-icon">
                <FaAngleDown
                  style={{
                    transform: expandedSection === 'overview' ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </span>
            </button>
            {expandedSection === 'overview' && (
              <ul className="sub-list">
                <li>
                  <button
                    className="sidebar-button"
                    onClick={() => handleNavigation('/', 'home')}
                  >
                    <span className="sidebar-icon"><IoHome /></span> Home
                  </button>
                </li>
                <li>
                  <button className="sidebar-button" onClick={() => handleNavigation('/profile', 'profile')}>
                    <span className="sidebar-icon"><FaUser /></span> Profile
                  </button>
                </li>
              </ul>
            )}
          </li>
          
          
          <li>
            <button
              className="sidebar-button"
              onClick={() => toggleSection('support')}
            >
              <span className="sidebar-icon"><MdOutlineSupportAgent /></span> Support
              <span className="angle-icon">
                <FaAngleDown
                  style={{
                    transform: expandedSection === 'support' ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </span>
            </button>
            {expandedSection === 'support' && (
              <ul className="sub-list">
                <li>
                  <button className="sidebar-button"
                    onClick={() => handleNavigation('/term', 'Terms')}
                  >
                    <span className="sidebar-icon"><FaMinus /></span> Terms & Policy
                  </button>
                </li>
                <li>
                  <button className="sidebar-button"
                    onClick={() => handleNavigation('/help', 'Center')}
                  >
                    <span className="sidebar-icon"><FaMinus /></span> Help Center
                  </button>
                </li>
                
              </ul>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;  